module.exports = __webpack_public_path__ + "static/media/close.ae8b5807.svg";